var _defs, _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPinchValve(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 80 80",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1, .cls-2 {\r\n        stroke-width: 0px;\r\n      }\r\n\r\n      .cls-2 {\r\n        fill: #fff;\r\n      }\r\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m57.5,40.4h-13v-17.2h6.3c.7,0,1.4-.5,1.4-1.4v-12c0-.7-.5-1.4-1.4-1.4h-21.6c-.7,0-1.4.5-1.4,1.4v12.1c0,.7.5,1.4,1.4,1.4h6.3v17.1h-13c-.7,0-1.2.5-1.2,1.2v2.6l16.6,12.4c1.2,1.1,2.7,1,4,0l16.9-12.4v-2.6c0-.7-.6-1.2-1.3-1.2Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m64.6,23.5H15.4c-1.5,0-2.7,1.2-2.7,2.7v42.6c0,1.5,1.2,2.7,2.7,2.7h49.3c1.5,0,2.7-1.2,2.7-2.7V26.3c0-1.6-1.3-2.8-2.8-2.8Zm-5.9,29.9l-16.4,12.6c-1.4,1.1-3.4,1.1-4.8,0l-16.3-12.6v-26.1h37.5v26.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m64.6,72.1H15.4c-1.8,0-3.2-1.4-3.2-3.2V26.3c0-1.8,1.4-3.2,3.2-3.2h49.3c1.8,0,3.2,1.4,3.2,3.2v42.6c0,1.7-1.5,3.2-3.3,3.2ZM15.4,24c-1.2,0-2.2,1-2.2,2.2v42.6c0,1.2,1,2.2,2.2,2.2h49.3c1.2,0,2.2-1,2.2-2.2V26.3c0-1.2-1-2.2-2.2-2.2H15.4v-.1Zm24.5,43.3c-1,0-1.9-.3-2.7-.9l-16.4-12.7v-26.9h38.5v26.9l-16.7,12.7c-.8.6-1.8.9-2.7.9Zm-18.1-14.1l16,12.4c1.2,1,3,1,4.2,0l16.3-12.4v-25.4H21.8v25.4Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPinchValve);
export default __webpack_public_path__ + "static/media/pinchValve.e61a672be88e7151c948a30dd1435c8f.svg";
export { ForwardRef as ReactComponent };